<template>
  <v-app>
    <v-content>
      <v-container fluid pt-5 mt-5>
        <v-dialog v-model="dialog_contract" scrollable>
          <v-card>
            <v-card-title>
              <span
                class="headline primary--text"
              >{{ `register.dialog_contract.${dialogkey_contract}` | t }}</span>
            </v-card-title>
            <v-card-text>
              <span v-html="contract[dialogkey_contract]"></span>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions align-right>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                flat="flat"
                @click.native="dialog_contract = false"
              >{{ `register.dialog_contract.close` | t }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" max-width="290">
          <v-card>
            <v-card-title class="headline">{{ `register.dialog.${dialogkey}.title` | t }}</v-card-title>
            <v-card-text>{{ `register.dialog.${dialogkey}.text` | t }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                flat
                @click.native="dialog = false"
              >{{ `register.dialog.${dialogkey}.confirm` | t }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-flex md7 sm6 offset-sm3>
          <v-card>
            <v-card-title primary-title>
              <v-flex md12>
                <h3 class="headline mb-0">{{ "register.title" | t }}</h3>
                <v-flex md12>
                  <v-form v-model="valid" ref="form">
                    <v-layout row wrap>
                      <v-flex md12>
                        <v-text-field
                          :label="$t('register.mail')"
                          v-model="mail"
                          :rules="mailRules"
                          prepend-icon="mail"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md12>
                        <v-text-field
                          :label="$t('userform.password')"
                          v-model="password"
                          :rules="passwordRules"
                          prepend-icon="vpn_key"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md12>
                        <v-btn flat color="indigo darken-4" @click="readTerms('terms')">
                          <v-icon>gavel</v-icon>
                          {{ 'register.terms_text' | t }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md12>
                        <v-btn flat color="indigo darken-4" @click="readTerms('privacy')">
                          <v-icon>lock</v-icon>
                          {{ 'register.privacy_text' | t }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-checkbox
                          :label="$t('register.terms_check')"
                          v-model="terms"
                          :rules="termsRules"
                          required
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-flex>
              </v-flex>
            </v-card-title>
            <v-card-actions>
              <v-layout row wrap>
                <v-flex sm12 md6>
                  <vue-recaptcha
                    sitekey="6LdaG0IUAAAAAMNWSJdbGJc-D-CQlZQpRKd3tHb0"
                    ref="recaptcha"
                    @verify="onVerify"
                    @expired="onExpired"
                  ></vue-recaptcha>
                </v-flex>
                <v-flex sm12 md5 offset-md1>
                  <v-btn
                    @click="confirmreg"
                    :disabled="nocaptcha"
                    :loading="loading"
                    block
                    color="primary white--text"
                  >{{ 'register.button.confirm' | t }}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { mapGetters } from "vuex";

export default {
  components: {
    VueRecaptcha
  },
  computed: {
    ...mapGetters(["getServer"])
  },
  data() {
    return {
      mail: "",
      password: "",
      terms: false,
      dialog: false,
      dialogkey: "confirm",
      dialog_contract: false,
      dialogkey_contract: "terms",
      contract: {
        terms: "TERMS TEXT",
        privacy: "PRIVACY TEXT"
      },
      valid: true,
      nocaptcha: true,
      loading: false,
      verify: "",
      mailRules: [
        v => !!v || this.$i18n.t("register.rules.mail_required"),
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$i18n.t("register.rules.mail_valid")
      ],
      passwordRules: [
        v =>
          /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{8,})/.test(v) ||
          this.$i18n.t("userform.rules.password_required")
      ],
      termsRules: [
        v => v !== false || this.$i18n.t("register.rules.terms_check")
      ]
    };
  },
  created() {
    this.$http
      .get(`${this.getServer}/terms`)
      .then(res => {
        this.contract = res.data;
      })
      .catch(() => {
        alert("PROBLEMS LOADING DATA");
      });
  },
  mounted() {
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  },
  methods: {
    readTerms(key) {
      this.dialogkey_contract = key;
      this.dialog_contract = true;
    },
    onVerify(response) {
      this.verify = response;
      this.nocaptcha = false;
    },
    onExpired() {
      this.nocaptcha = true;
    },
    confirmreg() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.nocaptcha = true;
        const userdata = {
          mail: this.mail.toLowerCase().trim(),
          password: this.password.trim(),
          verify: this.verify
        };
        this.$http
          .post(`${this.getServer}/register`, userdata)
          .then(data => {
            this.$refs.recaptcha.reset();
            if (data.data.res !== undefined) this.dialogkey = data.data.res;
            else if (data.data.error) this.dialogkey = data.data.error;
            else this.dialogkey = "problems";
            this.dialog = true;
            this.valid = true;
            this.loading = false;
          })
          .catch(() => {
            this.$refs.recaptcha.reset();
            this.dialogkey = "problems";
            this.dialog = true;
            this.valid = true;
            this.loading = false;
          });
      } else {
        this.dialogkey = "invaliddata";
        this.dialog = true;
      }
    }
  }
};
</script>